import { render, staticRenderFns } from "./LiveloPoints.vue?vue&type=template&id=790c4493&scoped=true"
import script from "./LiveloPoints.vue?vue&type=script&lang=js"
export * from "./LiveloPoints.vue?vue&type=script&lang=js"
import style0 from "./LiveloPoints.vue?vue&type=style&index=0&id=790c4493&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790c4493",
  null
  
)

export default component.exports